/* Given a collection of courses, returns a promise for their VC prices. */
import { getPricesForProducts } from 'bundles/ownable-products-common/promises/productPrices';
import { VERIFIED_CERTIFICATE } from 'bundles/payments-common/common/ProductType';

export default (courseIds: $TSFixMe) => {
  const vcProducts = courseIds.map((courseId: $TSFixMe) => ({
    productType: VERIFIED_CERTIFICATE,
    productTypeId: courseId,
  }));

  const promise = getPricesForProducts(vcProducts);
  promise.done();
  return promise;
};
